/**
 * @description
 * 
 * Store any data procesing for store here, to avoid bloating other module files
 * @param {*} someParam
 */
function someRandomFunction(someParam) {
}

function getUser(response) {
    return JSON.stringify(response.data.user.hr_employee)
}

function getAccessToken_FromLoginResponse(response) {
    return response.data.token_type + ' ' + response.data.access_token
}

export default {
    someRandomFunction,
    getUser,
    getAccessToken_FromLoginResponse,
}
